// Map team names → ISO 3166-1 alpha-2 code (used by flagcdn.com).
// Covers FIFA World Cup 2026 confirmed/potential participants and common Czech aliases.
const MAP: Record<string, string> = {
  // Hosts
  "canada": "ca", "kanada": "ca",
  "mexico": "mx", "mexiko": "mx",
  "usa": "us", "united states": "us", "spojené státy": "us",
  // UEFA
  "argentina": "ar",
  "france": "fr", "francie": "fr",
  "england": "gb-eng", "anglie": "gb-eng",
  "spain": "es", "španělsko": "es",
  "germany": "de", "německo": "de",
  "portugal": "pt", "portugalsko": "pt",
  "netherlands": "nl", "nizozemsko": "nl",
  "belgium": "be", "belgie": "be",
  "italy": "it", "itálie": "it",
  "croatia": "hr", "chorvatsko": "hr",
  "switzerland": "ch", "švýcarsko": "ch",
  "denmark": "dk", "dánsko": "dk",
  "poland": "pl", "polsko": "pl",
  "serbia": "rs", "srbsko": "rs",
  "austria": "at", "rakousko": "at",
  "scotland": "gb-sct", "skotsko": "gb-sct",
  "wales": "gb-wls",
  "turkey": "tr", "türkiye": "tr", "turecko": "tr",
  "norway": "no", "norsko": "no",
  "ukraine": "ua", "ukrajina": "ua",
  "czechia": "cz", "česko": "cz", "česká republika": "cz", "czech republic": "cz",
  "sweden": "se", "švédsko": "se",
  "hungary": "hu", "maďarsko": "hu",
  "romania": "ro", "rumunsko": "ro",
  "greece": "gr", "řecko": "gr",
  "slovenia": "si", "slovinsko": "si",
  "slovakia": "sk", "slovensko": "sk",
  "republic of ireland": "ie", "ireland": "ie", "irsko": "ie",
  "albania": "al", "albánie": "al",
  // CONMEBOL
  "brazil": "br", "brazílie": "br",
  "uruguay": "uy",
  "colombia": "co", "kolumbie": "co",
  "ecuador": "ec",
  "paraguay": "py",
  "venezuela": "ve",
  "bolivia": "bo", "bolívie": "bo",
  "chile": "cl",
  "peru": "pe",
  // CONCACAF
  "costa rica": "cr", "kostarika": "cr",
  "panama": "pa", "panamá": "pa",
  "honduras": "hn",
  "jamaica": "jm",
  "haiti": "ht", "haïti": "ht",
  "el salvador": "sv",
  "curacao": "cw", "curaçao": "cw",
  "guatemala": "gt",
  "trinidad and tobago": "tt",
  // AFC
  "japan": "jp", "japonsko": "jp",
  "iran": "ir", "írán": "ir", "ir iran": "ir",
  "korea republic": "kr", "south korea": "kr", "korea": "kr", "jižní korea": "kr",
  "australia": "au", "austrálie": "au",
  "saudi arabia": "sa", "saúdská arábie": "sa",
  "qatar": "qa", "katar": "qa",
  "uzbekistan": "uz",
  "jordan": "jo", "jordánsko": "jo",
  "iraq": "iq", "irák": "iq",
  "united arab emirates": "ae", "uae": "ae",
  "oman": "om", "omán": "om",
  // CAF
  "morocco": "ma", "maroko": "ma",
  "senegal": "sn",
  "tunisia": "tn", "tunisko": "tn",
  "egypt": "eg",
  "algeria": "dz", "alžírsko": "dz",
  "nigeria": "ng", "nigérie": "ng",
  "ghana": "gh",
  "cameroon": "cm", "kamerun": "cm",
  "ivory coast": "ci", "côte d'ivoire": "ci", "cote d'ivoire": "ci", "pobřeží slonoviny": "ci",
  "south africa": "za", "jižní afrika": "za",
  "mali": "ml",
  "cape verde": "cv", "cabo verde": "cv",
  // OFC
  "new zealand": "nz", "nový zéland": "nz",
};

const normalize = (s: string) =>
  s.toLowerCase().normalize("NFKD").replace(/[\u0300-\u036f]/g, "").trim();

/** Resolve a team name to a country code; returns null for placeholders (Winner Group A, TBD, …). */
export function teamCountryCode(team: string | null | undefined): string | null {
  if (!team) return null;
  const key = normalize(team);
  if (MAP[key]) return MAP[key];
  // unaccented lookup against normalized keys
  for (const [k, v] of Object.entries(MAP)) {
    if (normalize(k) === key) return v;
  }
  return null;
}

export function flagUrl(team: string | null | undefined, size: 40 | 80 | 160 = 80): string | null {
  const code = teamCountryCode(team);
  return code ? `https://flagcdn.com/w${size}/${code}.png` : null;
}
